<template>
  <div class="customs-broker-main">
    <div class="customs-broker">
      <div class="customs-broker_cards">
        <div class="customs-broker_cards-title">
          <div class="customs-broker_cards-title-meta">
            <img
              class="customs-broker_cards-title-meta-photo"
              v-lazy="
                require(`@/assets/images/core-service/customs-broker-1.png`)
              "
              alt=""
            />
          </div>
        </div>
      </div>
    </div>

    <div class="customs-broker-text">
      <div class="customs-broker-text-blog-card">
        <div class="customs-broker-text-blog-card-text">
          <div>
            <p class="customs-broker-text-blog-card-text-description">
              With professional experiences and understanding of local
              Vietnamese companies, product regulations, taxation practices,
              customs requirements, WR1 always provides the fastest and most
              flexible customs clearance services to all customers.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
<style lang="scss" scoped>
.customs-broker-main {
  position: relative;

  @media (min-width: 1024px) {
    &:nth-child(1) {
      &::after {
        content: "";
        position: absolute;
        top: 15%;
        transform: translate(0, -50%);
        right: -80px;
        background-image: url("../../../../../assets/images/core-service/core-top.png");
        background-size: 300px 300px;
        display: inline-block;
        width: 300px;
        height: 300px;
      }
      &::before {
        content: "";
        position: absolute;
        bottom: 250px;
        left: -120px;
        background-image: url("../../../../../assets/images/core-service/core-bottom.png");
        background-size: 300px 300px;
        display: inline-block;
        width: 300px;
        height: 300px;
      }
    }
  }

  .customs-broker {
    @media (min-width: 900px) {
      padding: 70px 70px;
    }
    @media (min-width: 1024px) {
      padding: 70px 230px;
    }
    @media (min-width: 1900px) {
      padding: 100px 470px;
    }
    &_cards {
      padding: 40px;

      @media (min-width: 900px) {
        padding-left: 0;
      }
      &-title {
        color: var(--text-normal-color);
        font-style: var(--normal-font-size);
        font-weight: 400;
        &-meta {
          &-photo {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
    }
  }

  .customs-broker-text {
    @media (min-width: 900px) {
      padding: 40px 70px 70px;
    }
    @media (min-width: 1024px) {
      padding: 40px 70px 230px;
    }
    @media (min-width: 1900px) {
      padding: 100px 470px;
    }
    background-color: var(--bg-color-2);

    &-blog-card {
      &-text {
        padding: 30px;
        display: flex;
        flex-direction: column;
        gap: 30px;

        &-description {
          color: var(--text-normal-color);
          font-style: var(--normal-font-size);
          font-weight: 400;
          ul {
            li {
              list-style: none !important;
              &::before {
                content: "\2022";
                color: #2b938c;
                font-weight: bold;
                display: inline-block;
                font-size: 20px;
                width: 1em;
                margin-left: -1.5em;
                margin-right: -10px;
              }
            }
          }
        }
      }
    }
  }
}
</style>